<script>
  import { onDestroy } from 'svelte';
  import { currentScreen, activeMatch, peerRole } from '../store.js';
  import { setupRecorderPeerHandlers } from '../../sync/peer-controller.js';
  import { PeerSync } from '../../peer-sync.js';
  import { saveDeviceSession } from '../../session-storage.js';

  let code = "";
  let statusMessage = "";
  let isError = false;
  let isConnecting = false;
  let joined = false;

  const unsubscribe = activeMatch.subscribe(match => {
    if (!isConnecting || !match?._remoteControlled) return;
    joined = true;
    isConnecting = false;
    statusMessage = "Connected!";
    isError = false;
    peerRole.set("recorder");
    currentScreen.set('recording');
  });

  onDestroy(() => {
    unsubscribe();
    if (isConnecting && !joined) PeerSync.disconnect();
  });

  function filterInput(event) {
    code = event.target.value.replace(/\D/g, "").slice(0, 6);
    event.target.value = code;
  }

  async function connect() {
    if (isConnecting) return;
    try { window._audioCtx = window._audioCtx || new (window.AudioContext || window.webkitAudioContext)(); } catch (_) {}
    if (code.length !== 6) {
      statusMessage = "Enter a valid 6-digit code";
      isError = true;
      return;
    }

    statusMessage = "Connecting...";
    isError = false;
    isConnecting = true;
    try {
      setupRecorderPeerHandlers();
      await PeerSync.joinRoom(code);
      saveDeviceSession({ role: 'recorder', roomCode: code, screen: 'recording' });
      statusMessage = "Connected, waiting for scorer data...";
    } catch (err) {
      isConnecting = false;
      statusMessage = "Connection failed: " + err.message;
      isError = true;
    }
  }

  function goBack() {
    isConnecting = false;
    PeerSync.disconnect();
    currentScreen.set('home');
  }
</script>

<div class="screen" id="recorder-join-screen">
  <div style="text-align:center; padding:20px 0 10px">
    <div style="font-size:48px; margin-bottom:8px">REC</div>
    <h1 style="margin:0 0 4px; font-size:22px">Join as Recorder</h1>
    <p class="muted" style="font-size:12px; margin:0 0 20px">
      Enter the 6-digit code shown on the scorer phone. This phone records the camera with synced overlays and animations.
    </p>
  </div>

  <input type="tel" inputmode="numeric" maxlength="6" placeholder="Enter 6-digit code"
    bind:value={code} on:input={filterInput}
    style="width:100%; text-align:center; font-family:monospace; font-size:32px; font-weight:900; letter-spacing:8px; padding:16px; background:#0f172a; border:2px solid #334155; border-radius:12px; color:#fff; margin-bottom:16px; outline:none;" />

  <div id="recorder-join-status" style="min-height:40px; margin-bottom:16px; text-align:center">
    {#if statusMessage}
      <div style="color:{isError ? '#f87171' : '#34d399'}; font-size:12px">{statusMessage}</div>
    {/if}
  </div>

  <button class="btn btn-primary btn-block" disabled={isConnecting}
    style="font-size:16px; padding:14px; margin-bottom:12px; background:linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);"
    on:click={connect}>
    {isConnecting ? 'CONNECTING...' : 'CONNECT & SYNC'}
  </button>
  <button class="btn btn-block btn-ghost" on:click={goBack}>Back</button>
</div>
